// extracted by mini-css-extract-plugin
export default {"Ad_bar_ts":"AdvertisementBar_Ad_bar_ts__MXPpl","red":"AdvertisementBar_red__iF5wA","emoji":"AdvertisementBar_emoji__6sIjV","enroll_btn":"AdvertisementBar_enroll_btn__BADlz"};